// @flow strict
import * as React from 'react'

import styles from './Card.module.scss'
import objectToQueryString from '@mondough/public-web-components/src/utils/objectToQueryString'

type PictureProps = {
  src: string,
  alt: string,
}

const Picture = ({ src, alt }: PictureProps) => {
  // Note: these parameters only work for images served by the contentful images api
  // See: https://www.contentful.com/developers/docs/references/images-api/
  const defaultImageSettings = {
    w: 100,
    fm: 'jpg',
    q: 85,
  }

  const MOBILE_IMAGE_MAX_WIDTH = 388
  const DESKTOP_IMAGE_MAX_WIDTH = 564
  const options = { startWithQuestionMark: true }

  const mobileNormal = `${src}${objectToQueryString(
    {
      ...defaultImageSettings,
      w: MOBILE_IMAGE_MAX_WIDTH,
    },
    options,
  )}`
  const mobileRetina = `${src}${objectToQueryString(
    {
      ...defaultImageSettings,
      w: MOBILE_IMAGE_MAX_WIDTH * 1.5,
    },
    options,
  )}`
  const desktopNormal = `${src}${objectToQueryString(
    {
      ...defaultImageSettings,
      w: DESKTOP_IMAGE_MAX_WIDTH,
    },
    options,
  )}`
  const desktopRetina = `${src}${objectToQueryString(
    {
      ...defaultImageSettings,
      w: DESKTOP_IMAGE_MAX_WIDTH * 1.5,
    },
    options,
  )}`

  return (
    <div className={styles.image}>
      <picture>
        <source
          media="(max-width: 420px)"
          srcSet={`${mobileNormal} 1x, ${mobileRetina} 2x`}
        />

        <source srcSet={`${desktopNormal} 1x, ${desktopRetina} 2x`} />
        <img src={desktopNormal} alt={alt} />
      </picture>
    </div>
  )
}
export default Picture
